//AppShell.tsx

import React, { useState } from "react";
import AuthProvider from "./AuthProvider";
import { useAuth } from "./hooks/useAuth";
import MyComponent from "./MyComponentLazy";
import LoginPage from "./auth/LoginPage";
import ResetPasswordPage from "./auth/ResetPasswordPage";
import AdminPage from "./auth/AdminPage";

function AppRoutes() {
  const { user, loading }       = useAuth();
  const [showAdmin, setAdmin]   = useState(false);
  const path = window.location.pathname;

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex',
                    alignItems: 'center', justifyContent: 'center',
                    background: '#eef1f6' }}>
        <div style={{ width: 36, height: 36, border: '3px solid #c8d4e0',
                      borderTopColor: '#1e3a6e', borderRadius: '50%',
                      animation: 'spin 0.8s linear infinite' }} />
      </div>
    );
  }

  if (path === '/forgot-password' || path === '/reset-password') {
    return <ResetPasswordPage />;
  }

  if (!user) return <LoginPage />;

  if (showAdmin && user.is_admin) {
    return <AdminPage onClose={() => setAdmin(false)} />;
  }

  // Pass onAdminOpen down so AppHeader inside MyComponent can open it
  // MyComponent renders its own AppHeader — we inject onAdminOpen via a
  // global so we don't touch MyComponent at all
  (window as any).__adriva_openAdmin = () => setAdmin(true);

  return <MyComponent />;
}

export default function AppShell() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}

const s = document.createElement('style');
s.textContent = `@keyframes spin { to { transform: rotate(360deg); } }`;
document.head.appendChild(s);